import React, { useEffect, useState } from 'react';
import IFrameFullscreen from './iframe-fullscreen.component';
import { useKato } from '../../../../contexts/kato.context';
import { KatoType } from '../../../../types/kato.types';
import { useUser } from '../../../../contexts/user.context';

const aktobeLink =
  'https://pbi.csi.kz/Report1/powerbi/Aktobe/Aktobe_%D0%B4%D0%BE%D1%85%D0%BE%D0%B4%D1%8B_%D1%80%D0%B0%D0%B9%D0%BE%D0%BD%D0%B0_%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C?rs:embed=true';
const irgizLink =
  'https://pbi.csi.kz/Report1/powerbi/Aktobe/Aktobe_%D0%B4%D0%BE%D1%85%D0%BE%D0%B4%D1%8B_%D1%80%D0%B0%D0%B9%D0%BE%D0%BD%D0%B0?rs:embed=true';

const TaxFullscreen = () => {
  const [link, setLink] = useState<string>('');
  const {
    currentLevel,
    katoGeneralInfo: { incomeStats },
  } = useKato();
  const { modules } = useUser();

  useEffect(() => {
    if (modules.includes('autolink') && incomeStats?.iframeUrlAlt) {
      setLink(incomeStats.iframeUrlAlt);
    } else if (currentLevel === KatoType.OBLAST) {
      setLink(aktobeLink);
    } else {
      setLink(irgizLink);
    }
  }, [currentLevel]);

  return <IFrameFullscreen link={link} title={'Tax Fullscreen'} />;
};

export default TaxFullscreen;
